export const TOP_BAR_PIN_MIN_DESKTOP_WIDTH = 1366;

// 5 tag icons + up to 8 view icons + pin: 14 * 36px = 504px.
// Group gaps (3 + 6 + 18), strip gaps (9), and two dividers (26) add 62px.
export const PINNED_QUICK_SETTINGS_MAX_WIDTH = 566;
export const PINNED_QUICK_SETTINGS_HOST_MARGIN = 32; // 16px on either side
const CLEARANCE = 8;

export function canFitPinnedQuickSettings({ viewportWidth, innerWidth, breadcrumbWidth, actionsWidth }) {
  return viewportWidth >= TOP_BAR_PIN_MIN_DESKTOP_WIDTH && innerWidth > 0 &&
    innerWidth >= breadcrumbWidth + actionsWidth + PINNED_QUICK_SETTINGS_MAX_WIDTH +
      PINNED_QUICK_SETTINGS_HOST_MARGIN + CLEARANCE;
}
